import React from 'react'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import CardList from '../components/CardList'
import PortfolioCard from '../components/PortfolioCard'
import Helmet from 'react-helmet'
import Wrapper from '../components/Wrapper'
import Hero from '../components/Hero'
import Pagination from '../components/Pagination'
import SEO from '../components/SEO'
import config from '../utils/siteConfig'

const Index = ({ data, pageContext, location }) => {
  const posts = data.allContentfulPortfolio.edges
  const featuredPost = posts[0].node
  const { currentPage } = pageContext
  const isFirstPage = currentPage === 1

  return (
    <Layout location={location}>
      <SEO />
      {!isFirstPage && (
        <Helmet>
          <title>{`${config.siteTitle} - Page ${currentPage}`}</title>
        </Helmet>
      )}
      <Wrapper>
        <Hero
          title="Front End Developer / UI Designer"
          subtitle="Passionate about creating clean and intuitive experiences, I bring an extensive product background mixed with a keen eye for minimalistic design."
          isHome
        />
        {isFirstPage ? (
          <CardList>
            <PortfolioCard {...featuredPost} featured />
            {posts.slice(1).map(({ node: post }) => (
              <PortfolioCard key={post.id} {...post} />
            ))}
          </CardList>
        ) : (
          <CardList>
            {posts.map(({ node: post }) => (
              <PortfolioCard key={post.id} {...post} />
            ))}
          </CardList>
        )}
      </Wrapper>
      <Pagination context={pageContext} />
    </Layout>
  )
}

export const query = graphql`
  query($skip: Int!, $limit: Int!) {
    allContentfulPortfolio(
      sort: { fields: [publishDate], order: DESC }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          title
          id
          slug
          publishDate(formatString: "MMMM DD, YYYY")
          cardImage {
            title
            fluid(maxWidth: 1800) {
              ...GatsbyContentfulFluid_withWebp_noBase64
            }
          }
          body {
            childMarkdownRemark {
              html
            }
          }
          description {
            childContentfulRichText {
              html
            }
          }
        }
      }
    }
  }
`

export default Index
